import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const editManager: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { userApi },
) =>
  action$.pipe(
    ofType(actions.EDIT_MANAGER_ACTIONS.REQUESTED),
    switchMap(({ payload: { manager } }) =>
      userApi.editManager(manager).pipe(
        switchMap(({ newManager }) =>
          of(actions.editManagerSucceeded(newManager)),
        ),
        catchError(error => of(actions.editManagerFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Managers/services/epics/editManager.ts